var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipTipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64772 1.15519C9.10218 0.201675 7.72713 0.201678 7.18158 1.15519L0.612752 12.6364C0.0708949 13.5834 0.754698 14.7625 1.84582 14.7625L14.9835 14.7625C16.0746 14.7625 16.7584 13.5834 16.2165 12.6364L9.64772 1.15519Z",
    fill: "#2078E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipTipIcon);
export default __webpack_public_path__ + "static/media/TooltipTipIcon.f4fdf6a3a62384fd44b5c08f859b0a93.svg";
export { ForwardRef as ReactComponent };